var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSudenpennut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sudenpennut ON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sudenpennut-ON",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3650A1",
    fillRule: "nonzero",
    cx: 500,
    cy: 500,
    r: 490
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.19931,418.978537 L253.400371,489.168988 L346.811361,591.921077 L470.10862,848 L529.89138,848 L653.188639,591.921077 L746.741672,489.012741 L738.744769,409.043714 L641.685929,214.926033 L617.738382,322.689991 L500,375.018161 L382.261618,322.689991 L358.753278,216.902461 L261.19931,418.978537 Z M230,410 L370,120 L410,300 L500,340 L590,300 L630,120 L770,400 L780,500 L680,610 L550,880 L450,880 L320,610 L220,500 L230,410 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.166092,508 L443.405369,508 L452.802608,475.109662 L379.725391,454.230457 L404.166092,508 Z M340,420 L480,460 L460,530 L390,530 L340,420 Z",
    id: "Rectangle-5",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.166092,508 L623.405369,508 L632.802608,475.109662 L559.725391,454.230457 L584.166092,508 Z M520,420 L660,460 L640,530 L570,530 L520,420 Z",
    id: "Rectangle-5",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(590.000000, 475.000000) scale(-1, 1) translate(-590.000000, -475.000000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudenpennut);
export default __webpack_public_path__ + "static/media/sudenpennut.977e06b01fdb34e34d862a56cac634af.svg";
export { ForwardRef as ReactComponent };